<template>
    <div class="bg-F6F7FA">
        <CCol sm="12">
    
    
            <CCol sm="12">
                <CCard class="p-2 custom-bg-card">
                    <CCol sm="12">
                        <CRow>
                            <CCol sm="8">
                                <div class="d-flex">
                                    <CInput type="text" class="mr-2" />
                                </div>
                            </CCol>
                            <CCol sm="4">
                                <div class="text-right">
                                    <CRow class="text-right">
                                        <CCol col="12" sm="12" lg="8">
                                            <CButton class="bg-7F56D9 text-white" @click="OpenAdd()"><img src="../assets/image/add.png" style="max-width:20px" class="mr-1" />Add User</CButton>
                                        </CCol>
                                        <CCol col="12" sm="12" lg="4">
                                            <CButton type="button" class="bg-white custom-bg-btn-white-border" style="height:40px;border-radius:2px"><img src="../assets/image/sort.png" style="max-width:20px" class="mr-1" />Filter</CButton>
                                        </CCol>
                                    </CRow>
    
    
                                </div>
                            </CCol>
                        </CRow>
                    </CCol>
    
                    <div class="table-container" style="width:100%">
                        <table class="table table-responsive-sm">
                            <thead class="custom-bg-header-table">
                                <tr style="border-bottom:1px solid #F2F4F7">
                                    <th><input type="checkbox" /></th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Role</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td><img src="../assets/image/user1.png" width="40px" class="mr-2" />Jane Cooper</td>
                                    <td>Janecooper@gmail.com</td>
                                    <td>+60322450533</td>
                                    <td><span class="custom-blue-light">Admin</span></td>
                                    <td>
                                        <span @click="OpenDelete()"><img src="../assets/image/trash.png" width="20px" /> <strong class="text-danger">Delete</strong></span>
                                        <img src="../assets/image/edit.png" width="20px" class="ml-2" @click="OpenEdit()" /> <label class="custom-14px-500 font-color-9E77ED">Edit</label></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td><img src="../assets/image/user2.png" width="40px" class="mr-2" />Brooklyn Simmons</td>
                                    <td>Brookly@gmail.com</td>
                                    <td>+60322450533</td>
                                    <td><span class="custom-blue-light">Admin</span></td>
                                    <td>
                                        <img src="../assets/image/trash.png" width="20px" @click="OpenDelete()"/> <strong class="text-danger" @click="OpenDelete()">Delete</strong>
                                        <img src="../assets/image/edit.png" width="20px" class="ml-2" /> <label class="custom-14px-500 font-color-9E77ED">Edit</label></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td><img src="../assets/image/user1.png" width="40px" class="mr-2" />Jane Cooper</td>
                                    <td>Janecooper@gmail.com</td>
                                    <td>+60322450533</td>
                                    <td><span class="custom-blue-light">Admin</span></td>
                                    <td><img src="../assets/image/trash.png" width="20px" @click="OpenDelete()"/> <strong class="text-danger" @click="OpenDelete()">Delete</strong>
                                        <img src="../assets/image/edit.png" width="20px" class="ml-2" /> <label class="custom-14px-500 font-color-9E77ED">Edit</label></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td><img src="../assets/image/user2.png" width="40px" class="mr-2" />Brooklyn Simmons</td>
                                    <td>Brookly@gmail.com</td>
                                    <td>+60322450533</td>
                                    <td><span class="custom-blue-light">Admin</span></td>
                                    <td><img src="../assets/image/trash.png" width="20px" @click="OpenDelete()"/> <strong class="text-danger" @click="OpenDelete()">Delete</strong>
                                        <img src="../assets/image/edit.png" width="20px" class="ml-2" /> <label class="custom-14px-500 font-color-9E77ED">Edit</label></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td><img src="../assets/image/user1.png" width="40px" class="mr-2" />Jane Cooper</td>
                                    <td>Janecooper@gmail.com</td>
                                    <td>+60322450533</td>
                                    <td><span class="custom-blue-light">Admin</span></td>
                                    <td><img src="../assets/image/trash.png" width="20px" @click="OpenDelete()"/> <strong class="text-danger" @click="OpenDelete()">Delete</strong>
                                        <img src="../assets/image/edit.png" width="20px" class="ml-2" /> <label class="custom-14px-500 font-color-9E77ED">Edit</label></td>
                                </tr>
                                <tr>
                                    <td><input type="checkbox" /></td>
                                    <td><img src="../assets/image/user2.png" width="40px" class="mr-2" />Brooklyn Simmons</td>
                                    <td>Brookly@gmail.com</td>
                                    <td>+60322450533</td>
                                    <td><span class="custom-blue-light">Admin</span></td>
                                    <td><img src="../assets/image/trash.png" width="20px" @click="OpenDelete()"/> <strong class="text-danger" @click="OpenDelete()">Delete</strong>
                                        <img src="../assets/image/edit.png" width="20px" class="ml-2" /> <label class="custom-14px-500 font-color-9E77ED">Edit</label></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCard>
            </CCol>
    
        </CCol>
    
        <div v-if="isPopupAdd" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-22px-600 font-color-101828">Add User</h3>
                    </CCol>
                    <CCol sm="2">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAdd" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12">
                        <label class="custom-16px-500 font-color-101828">Name</label>
                        <input type="password" class="custom-bg-btn-white-border" style="width:100%" />
                    </CCol>
                    <CCol sm="6" class="mt-2">
                        <label class="custom-16px-500 font-color-101828">Email</label>
                        <input type="password" class="custom-bg-btn-white-border" style="width:100%" />
                    </CCol>
                    <CCol sm="6" class="mt-2">
                        <label class="custom-16px-500 font-color-101828">Role</label>
                        <input type="password" class="custom-bg-btn-white-border" style="width:100%" />
                        <div class="text-right">
                            <CButton class="bg-7F56D9 text-white mt-4 text-right" @click="OpenAdd()">Add User</CButton>
                        </div>
    
                    </CCol>
    
                </CRow>
            </div>
        </div>
    
        <div v-if="isPopupDelete" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img src="../assets/image/Tick.png" style="max-width:100px" />
                    <h3 class="custom-24px-600 font-color-101828 font-inter mt-4">Want to Delete User?</h3>
                    <p class="custom-16px-400 font-color-98A2B3">This action cannot be undone, and all data associated with this user will be permanently removed. Please confirm if you wish to proceed with the deletion.</p>
    
                    <CButton type="button" class="custom-danger-card text-white mt-4" block>Delete</CButton>
                    <label class="text-center font-color-98A2B3 mt-4" @click="closePopupDelete">Cancel</label>
                </div>
    
                <CRow>
    
    
                </CRow>
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'

import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        VueCal

    },

    data() {
        return {

            isPopupAdd: false,
            isPopupDelete: false
        }





    },
    async mounted() {
        // try {
        //     const isAuth = await this.UserAuth();
        //     if (isAuth) {


        //     } else {}
        // } catch (error) {
        //    // this.GoToPage();
        //     console.error("Error during authentication:", error);
        //     // Handle the error here
        // }

    },

    computed: {

    },

    methods: {
        OpenAdd() {
            this.isPopupAdd = true;
        },
        closePopupAdd() {
            this.isPopupAdd = false;
        },
        OpenDelete() {
            this.isPopupDelete = true;
        },
        closePopupDelete() {
            this.isPopupDelete = false;
        }


    }

};
</script>